import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { images } from '../../data/images';
import { QuickScoringButton } from '../credit/QuickScoringButton';
export function CreditCta() {
  return <section className="container-x py-16" aria-labelledby="credit-cta-title" data-id="element-677" data-mp="1fj77cbtgih67">
      <div className="grid overflow-hidden rounded-3xl border border-neon/30 bg-surface lg:grid-cols-2" data-id="element-678" data-mp="1jipttc0xf0b5">
        <div className="p-7 sm:p-12" data-id="element-679" data-mp="mvbe5h33j7e6">
          <h2 id="credit-cta-title" className="font-display text-3xl font-black leading-[1.02] tracking-tight sm:text-5xl" data-id="element-680" data-mp="rsur8do25e4j">
            CONOCÉ TUS ALTERNATIVAS PARA LLEGAR A TU <span className="text-neon" data-id="element-681" data-mp="vsvjp27zrpul">0 KM.</span>
          </h2>
          <p className="mt-5 max-w-md text-mist" data-id="element-682" data-mp="10lesllvqhwt2">
            Contanos tu anticipo disponible y tu situación laboral. Un asesor revisa tu caso y te propone las opciones de financiación que mejor se ajustan.
          </p>
          <ul className="mt-6 space-y-2 text-sm text-mist" data-id="element-683" data-mp="83j85vp6z5p4">
            <li data-id="element-684" data-mp="2i1y9zmdbdep8">Te pedimos sólo los datos estrictamente necesarios.</li>
            <li data-id="element-685" data-mp="2i41169q7ddvj">Seguís el estado de tu consulta con un número de seguimiento.</li>
            <li data-id="element-686" data-mp="2d3wt983d1rgx">No es una precalificación ni implica aprobación garantizada.</li>
          </ul>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-687" data-mp="28ak6z4m5lwrc">
            <Link to="/chequeo" className="btn btn-credit h-12 px-6" data-id="element-688" data-mp="23e3ig9b1lgdq">
              Iniciar evaluación preliminar
              <ArrowRightIcon className="h-4 w-4" aria-hidden data-id="element-689" data-mp="1yf0e6r2vze6t" />
            </Link>
            <QuickScoringButton data-id="element-690" data-mp="1ucdqn2d90fff" />
          </div>
        </div>
        <img src={images.interior} alt="Interior de un vehículo 0 km" className="h-64 w-full object-cover lg:h-full" loading="lazy" data-id="element-691" data-mp="1uezw8wgkwkv0" />
      </div>
    </section>;
}